import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { StarIcon, QuoteIcon } from 'lucide-react';
interface Testimonial {
  name: string;
  location: string;
  result: string;
  quote: string;
}
const testimonials: Testimonial[] = [{
  name: 'Carlos M.',
  location: 'Houston, TX',
  result: '3 contratos en 15 días',
  quote: 'Estaba a punto de cerrar mi negocio. Blindaje 21 me salvó. En dos semanas tenía trabajo para el próximo mes completo.'
}, {
  name: 'Miguel R.',
  location: 'Los Angeles, CA',
  result: '$12,000 en nuevos contratos',
  quote: 'El sistema de reactivación funcionó al instante. Llamé a 5 clientes viejos y 3 me dieron trabajo. Simple pero efectivo.'
}, {
  name: 'José L.',
  location: 'Phoenix, AZ',
  result: 'De 0 a 4 proyectos',
  quote: 'Ya no dependo de las plataformas caras. Ahora los clientes me buscan directamente. Esto cambió todo para mi familia.'
}];
export function Testimonials() {
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) {
        setIsVisible(true);
      }
    }, {
      threshold: 0.1
    });
    const section = document.getElementById('testimonials');
    if (section) {
      observer.observe(section);
    }
    return () => {
      if (section) {
        observer.unobserve(section);
      }
    };
  }, []);
  return <section id="testimonials" className="w-full bg-white py-16 md:py-24" data-id="element-289">
      <div className="max-w-4xl mx-auto px-4" data-id="element-290">
        <h2 className="font-heading text-3xl md:text-5xl text-blueprint-blue text-center mb-4" data-id="element-291">
          Contratistas que ya llenaron su calendario
        </h2>
        <p className="text-xl text-industrial-gray text-center mb-12" data-id="element-292">
          Resultados reales de personas como tú
        </p>

        <div className="space-y-8" data-id="element-293">
          {testimonials.map((testimonial, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} animate={isVisible ? {
          opacity: 1,
          y: 0
        } : {
          opacity: 0,
          y: 30
        }} transition={{
          duration: 0.6,
          delay: index * 0.2
        }} className="bg-gray-50 p-8 rounded-lg border-l-4 border-safety-yellow shadow-md" data-id="element-294">
              <div className="flex items-start gap-4 mb-4" data-id="element-295">
                <QuoteIcon className="w-8 h-8 text-safety-yellow flex-shrink-0" aria-hidden="true" data-id="element-296" />
                <p className="text-lg md:text-xl text-industrial-gray italic leading-relaxed" data-id="element-297">
                  "{testimonial.quote}"
                </p>
              </div>

              <div className="flex items-center justify-between flex-wrap gap-4 mt-6" data-id="element-298">
                <div data-id="element-299">
                  <p className="font-bold text-blueprint-blue text-lg" data-id="element-300">
                    {testimonial.name}
                  </p>
                  <p className="text-gray-600" data-id="element-301">{testimonial.location}</p>
                </div>

                <div className="bg-safety-yellow text-dark-gray font-bold px-4 py-2 rounded-lg" data-id="element-302">
                  {testimonial.result}
                </div>
              </div>

              <div className="flex gap-1 mt-4" aria-label="5 estrellas" data-id="element-303">
                {[...Array(5)].map((_, i) => <StarIcon key={i} className="w-5 h-5 fill-safety-yellow text-safety-yellow" aria-hidden="true" data-id="element-304" />)}
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}